import gql from 'graphql-tag'

export default gql`
  query GetProductCollection($slug: String!) {
    cfProductCollectionCollection(limit: 1, where: { slug: $slug }) {
      items {
        title
        bodyCopy
        shortDescription
        heroImageSet {
          masterSupportingColour
          master {
            url
          }
        }
        products {
          title
          brand
          variants {
            variantGroupCode
            sku
            originalPrice
            discountPrice
            effectivePrice
            images {
              url
            }
          }
          shop {
            id
            name
            retailer {
              title
              sys {
                id
              }
            }
          }
        }
      }
    }
  }
`
